import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/card';
import { ColumnChart } from '@/features/dashboard-charts';
import { DashboardFilterBar } from '@/features/dashboard-filters';

import { useTransportOverview } from '../lib/use-transport-overview';
import { PageHeader, TransportStats, ChartSection, TopListsGrid } from './components';

export function TransportOverviewPage() {
  const { t } = useTranslation();
  const { data, formattedStats, isLoading, error, options, updateOption } = useTransportOverview();

  if (error) {
    return (
      <div className="p-6">
        <Card className="p-6">
          <p className="text-destructive">Error loading transport overview data</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <PageHeader title={t('report_transport_overview_title', 'Transport Overview')} />

      <DashboardFilterBar variant="transport" options={options} onOptionChange={updateOption} />

      {data && formattedStats && (
        <>
          <TransportStats stats={formattedStats} />

          <ChartSection>
            <ColumnChart data={data.transport} height={400} loading={isLoading} />
          </ChartSection>

          <TopListsGrid
            topTransporters={data.topTransporters}
            topTransportUsers={data.topTransportUsers}
            isLoading={isLoading}
          />
        </>
      )}
    </div>
  );
}
